<template>
    <div class="m-team mb-48">
        <div v-if="services" class="m-team__services mt-8">
          <div :key="index" v-for="(service, index) in services">
              <section v-if="service.mitglieder.length" class="m-team__service revealservice mb-20">
                  <h2 class="mb-4">{{service.bezeichnung}}</h2>
                  <section class="m-team__members grid md:grid-cols-2 gap-10 xl:grid-cols-3 2xl:grid-cols-4 mt-8">
                      <article :key="index" v-for="(mitglied, index) in service.mitglieder">
                          <Member v-bind="mitglied"></Member>
                      </article>
                  </section>
              </section>
          </div>
        </div>
  </div>
</template>

<script>

import axios from 'axios';
import Member from './Member';
import { gsap } from 'gsap';
import { CSSPlugin } from 'gsap/CSSPlugin'
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
gsap.registerPlugin(CSSPlugin);
gsap.registerPlugin(ScrollTrigger);

export default {
    name: 'ServiceComponent',
    components: {
        Member
    },
    data: function() {
        return {
            services: null,
        };
    },
    mounted: function () {
        //init
        this.getServices()
    },
    methods: {
        animation: function() {
            let mTeam = gsap.utils.toArray('.m-team');
            mTeam.forEach(elem => {
                gsap.to(elem, {
                    autoAlpha: 1,
                    minHeight: 0,
                    stagger: 0.2,
                    y: 0,
                    duration: 0.5,
                    scrollTrigger: {
                        trigger: elem,
                    }
                })
            });

            let revealelements = gsap.utils.toArray('.revealservice');
            revealelements.forEach(elem => {
                gsap.from(elem, {
                    clearProps:"all",
                    stagger: 0.2,
                    y: 25,
                    duration: 0.5
                })
                gsap.to(elem, {
                    stagger: 0.2,
                    y: 0,
                    duration: 0.5
                })
            });
        },
        getBaseUrl: function() {
            //npm run serve
            if(process.env.NODE_ENV === "development") {
                return 'http://weberprevost.test'
            }
            return ''
        },
        getServices: function() {
            let self = this;
            let baseUrl = this.getBaseUrl()
            let params = {
                params: {
                    "order[sorting]": "asc"
                }
            }
            axios.get(baseUrl+'/_api/team/service',params,
                {

                })
                .then(function (response) {

                    let apiResponseData = response.data;

                    //set data
                    self.services = apiResponseData['hydra:member']

                    //animation
                    setTimeout(() => {
                        self.animation()
                    }, 100);

                })
                .catch(function () {

                });

        },
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.m-team {
    min-height: 3500px;
    opacity: 0;
}
</style>
